var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/hierarchy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hierarchy-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.81283 20.2328C3.16748 20.2328 1.83366 18.899 1.83366 17.2536C1.83366 15.6083 3.16748 14.2744 4.81283 14.2744C6.45817 14.2744 7.79199 15.6083 7.79199 17.2536C7.79199 18.899 6.45817 20.2328 4.81283 20.2328Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.58301 7.39944C3.06423 7.39944 1.83301 6.16823 1.83301 4.64944C1.83301 3.13066 3.06423 1.89944 4.58301 1.89944C6.10179 1.89944 7.33301 3.13066 7.33301 4.64944C7.33301 6.16823 6.10179 7.39944 4.58301 7.39944Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.417 7.39944C15.8982 7.39944 14.667 6.16823 14.667 4.64944C14.667 3.13066 15.8982 1.89944 17.417 1.89944C18.9358 1.89944 20.167 3.13066 20.167 4.64944C20.167 6.16823 18.9358 7.39944 17.417 7.39944Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.5725 7.41778C16.6834 9.96611 14.2817 11.6803 11.5775 11.6803C11.5684 11.6803 11.5592 11.6803 11.55 11.6803L8.31421 11.6711C6.92088 11.6528 5.67421 12.5969 5.29838 13.9536V15.6494C5.29838 16.0344 4.98671 16.3461 4.59254 16.3461C4.20754 16.3461 3.89588 16.0344 3.89588 15.6494V5.34611C3.89588 4.96111 4.20754 4.64944 4.59254 4.64944C4.97754 4.64944 5.29838 4.96111 5.29838 5.34611V11.4144C6.10504 10.6994 7.15921 10.2594 8.30504 10.2594C8.31421 10.2594 8.31421 10.2594 8.32338 10.2594L11.5592 10.2686C11.5684 10.2686 11.5684 10.2686 11.5775 10.2686C13.6767 10.2686 15.5559 8.93944 16.2434 6.95028C16.3534 6.66611 16.6192 6.48278 16.9125 6.48278C16.9859 6.48278 17.0684 6.50111 17.1417 6.51944C17.5084 6.64778 17.7009 7.05111 17.5725 7.41778Z",
    fill: "#FCFCFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKs);
export default __webpack_public_path__ + "static/media/ks.dcf6bbb7b69ba6a4ce00021103d9244b.svg";
export { ForwardRef as ReactComponent };